// The one ActivityClient for the app: where events go, who is signed in, and on which platform.

import { API_ROUTES, COOKIES } from "../constants";
import Cookies from "../utilities/cookies";
import { getIdentity } from "../utilities/identity";
import { ActivityClient } from "./client";

/**
 * The signed-in member: the token the site sends with every API call (src/api/_api.js), and
 * the user id saved with it at sign-in (src/utilities/identity.js). Null when either is missing.
 */
export function getAuth() {
  const token = Cookies.get({ name: COOKIES.AUTHORIZATION });
  const memberId = Number(getIdentity()?.uid);

  return token && Number.isInteger(memberId) && memberId > 0 ? { token, memberId } : null;
}

/** "web", or - inside the Maor app, which shows the site in a React Native WebView - the app's platform. */
export function getPlatform() {
  if (!window.ReactNativeWebView) {
    return "web";
  }

  return /android/i.test(navigator.userAgent) ? "android" : "ios";
}

export const activity = new ActivityClient({
  // eslint-disable-next-line no-undef
  endpoint: `${process.env.REACT_APP_API_URL}${API_ROUTES.ACTIVITY.EVENTS}`,
  getAuth,
  platform: getPlatform(),
});
